'use client';

import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

type Props = {
  label: string;
  icon: string;
  value: number | string;
  delta?: number;
  deltaLabel?: string;
  accent?: 'gold' | 'green' | 'blue' | 'purple';
};

const ACCENTS = {
  gold: '#D4AF37',
  green: '#22C55E',
  blue: '#3B82F6',
  purple: '#A855F7',
};

export default function StatCard({
  label,
  icon,
  value,
  delta,
  deltaLabel = '24h',
  accent = 'gold',
}: Props) {
  const color = ACCENTS[accent];
  const showDelta = delta !== undefined && delta !== 0;
  const DeltaIcon = delta && delta > 0 ? TrendingUp : delta && delta < 0 ? TrendingDown : Minus;
  const deltaColor = delta && delta > 0 ? '#22C55E' : delta && delta < 0 ? '#EF4444' : '#6B6B6B';
  const deltaText = delta && delta > 0 ? `+${delta}` : delta ? String(delta) : '—';

  return (
    <div style={{
      padding: 24,
      background: '#141414',
      border: '1px solid #2A2A2A',
      borderRadius: 14,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
        <div style={{
          width: 40, height: 40, borderRadius: 20,
          background: 'rgba(212, 175, 55, 0.1)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 20,
        }}>
          {icon}
        </div>
        {showDelta && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: 4,
            color: deltaColor, fontSize: 11, fontWeight: 600,
          }}>
            <DeltaIcon size={12} />
            <span>{deltaText}</span>
            <span style={{ color: '#6B6B6B', fontWeight: 400 }}>{deltaLabel}</span>
          </div>
        )}
      </div>

      <div style={{
        color: '#6B6B6B', fontSize: 11,
        letterSpacing: 2, marginBottom: 8,
      }}>
        {label}
      </div>
      <div style={{
        color, fontSize: 28, fontWeight: 700,
      }}>
        {value}
      </div>
    </div>
  );
}
